import template from './adpMainHeader.html';
import controller from './adpMainHeader.controller';
import './adpMainHeader.less';

let adpMainHeaderComponent = {
  restrict: 'E',
  bindings: {
    logoSrc: '@',
    logoAlt: '@',
  },
  transclude: true,
  template,
  controller
};

export default adpMainHeaderComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpMainHeader/adpMainHeader.component.js